module.exports = __webpack_public_path__ + "img/5-3.12549c32.png";